import { AssistantId } from "@genai/assistant";
import { httpClient, postProcessUpsert } from "@genai/http-client";
import { ApiChat, Chat } from "../model";

export const createChat = (
  assistantId: AssistantId,
  brand: string,
  model: string,
): Promise<Chat> =>
    httpClient(`/assistants/${assistantId}/chats`, {
      method: "POST",
      body: JSON.stringify({
        name: `${brand} - ${model}`,
        brand,
        model
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(postProcessUpsert<ApiChat>)
      .then((chat) => chat as Chat);
